export const {
  CANBOOK_DOMAIN = "canbook.app",
  CANBOOK_WEBSITE_DOMAIN = "www.canbook.app",
  CANBOOK_USER_APP_URL = "https://canbook.app",
  CANBOOK_BUSINESS_URL = "https://business.canbook.app",
  CANBOOK_WEBSITE_URL = "https://canbook.app",
  BUSINESS_URL = CANBOOK_USER_APP_URL + "/b/",
  RAZORPAY_SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js",
  RECAPTCHA_API_URL = "https://www.google.com/recaptcha/api.js?render=",
  LOCATION_SEARCH_API_URL = "https://places.googleapis.com/v1/places:searchText",
  APPSTORE_URL = "https://apps.apple.com/in/app/canbook-appointment-services/id6504726769?utm_source=website&utm_campaign=website_home",
  PLAYSTORE_URL = "https://play.google.com/store/apps/details?id=com.canbook&utm_source=website&utm_campaign=website_home",
  TERMS_AND_CONDITION_URL = CANBOOK_USER_APP_URL + "/terms-conditions",
  PRIVACY_POLICY_URL = CANBOOK_USER_APP_URL + "/privacy-policy",
} = {};
